import {TranslationMessages} from 'react-admin';
import russianMessages from 'ra-language-russian';

const customRussianMessages: TranslationMessages = {
    ...russianMessages,
    resources: {
        users: {
            name: 'Пользователь |||| Пользователи',
            fields: {
                id: 'ID',
                firstName: 'Имя',
                lastName: 'Фамилия',
                email: 'Email',
                name: 'Имя',
                role: 'Роль',
                isActive: 'Активен',
                createdAt: 'Создан',
                updatedAt: 'Обновлен',
            },
        },
        products: {
            name: 'Товар |||| Товары',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                description: 'Описание',
                price: 'Цена',
                sku: 'Артикул',
                quantity: 'Количество',
                weight: 'Вес (кг)',
                status: 'Статус',
                brandId: 'Бренд',
                categoryId: 'Категория',
                images: 'Изображения',
                catalogImages: 'Изображения для каталога',
                metaTitle: 'SEO заголовок',
                metaDescription: 'SEO описание',
                metaKeywords: 'SEO ключевые слова',
                documents: 'Документы',
                characteristics: 'Характеристики',
                attributeValues: 'Значения атрибутов',
                tags: 'Теги',
                featuredProducts: 'Рекомендуемые товары',
                configuratorGroups: 'Группы конфигуратора',
                createdAt: 'Создан',
                updatedAt: 'Обновлен',
            },
            tabs: {
                general: 'Основная информация',
                seo: 'SEO',
                media: 'Медиа',
                attributes: 'Характеристики и атрибуты',
                documents: 'Документы',
                configurator: 'Конфигуратор',
            },
        },
        brands: {
            name: 'Бренд |||| Бренды',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                country: 'Страна',
                description: 'Описание',
                logo: 'Логотип',
                createdAt: 'Создан',
                updatedAt: 'Обновлен',
            },
        },
        categories: {
            name: 'Категория |||| Категории',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                description: 'Описание',
                image: 'Изображение',
                icon: 'Иконка',
                parentId: 'Родительская категория',
                sortOrder: 'Порядок сортировки',
                isActive: 'Активна',
                metaTitle: 'SEO заголовок',
                metaDescription: 'SEO описание',
                metaKeywords: 'SEO ключевые слова',
                createdAt: 'Создана',
                updatedAt: 'Обновлена',
            },
        },
        tags: {
            name: 'Тег |||| Теги',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                description: 'Описание',
                color: 'Цвет',
                createdAt: 'Создан',
                updatedAt: 'Обновлен',
            },
        },
        'attribute-groups': {
            name: 'Группа атрибутов |||| Группы атрибутов',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                description: 'Описание',
                sortOrder: 'Порядок сортировки',
                createdAt: 'Создана',
                updatedAt: 'Обновлена',
            },
        },
        attributes: {
            name: 'Атрибут |||| Атрибуты',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                description: 'Описание',
                groupId: 'Группа атрибутов',
                sortOrder: 'Порядок сортировки',
                createdAt: 'Создан',
                updatedAt: 'Обновлен',
            },
        },
        'characteristic-groups': {
            name: 'Группа характеристик |||| Группы характеристик',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                description: 'Описание',
                sortOrder: 'Порядок сортировки',
                createdAt: 'Создана',
                updatedAt: 'Обновлена',
            },
        },
        characteristics: {
            name: 'Характеристика |||| Характеристики',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                description: 'Описание',
                unit: 'Единица измерения',
                groupId: 'Группа характеристик',
                sortOrder: 'Порядок сортировки',
                isActive: 'Активна',
                createdAt: 'Создана',
                updatedAt: 'Обновлена',
            },
        },
        media: {
            name: 'Медиафайл |||| Медиафайлы',
            fields: {
                id: 'ID',
                filename: 'Имя файла',
                originalName: 'Оригинальное имя',
                mimeType: 'Тип файла',
                size: 'Размер',
                path: 'Путь',
                url: 'URL',
                alt: 'Альтернативный текст',
                title: 'Заголовок',
                createdAt: 'Создан',
                updatedAt: 'Обновлен',
            },
        },
        collections: {
            name: 'Подборка |||| Подборки',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                description: 'Описание',
                image: 'Изображение',
                sortOrder: 'Порядок сортировки',
                isActive: 'Активна',
                metaTitle: 'SEO заголовок',
                metaDescription: 'SEO описание',
                metaKeywords: 'SEO ключевые слова',
                products: 'Товары',
                createdAt: 'Создана',
                updatedAt: 'Обновлена',
            },
        },
        'vacancy-categories': {
            name: 'Категория вакансий |||| Категории вакансий',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                isActive: 'Активна',
                sortOrder: 'Порядок сортировки',
                '_count.vacancies': 'Количество вакансий',
                createdAt: 'Создана',
                updatedAt: 'Обновлена',
            },
        },
        vacancies: {
            name: 'Вакансия |||| Вакансии',
            fields: {
                id: 'ID',
                title: 'Название вакансии',
                description: 'Описание',
                externalUrl: 'Внешняя ссылка',
                experience: 'Опыт работы',
                employment: 'Тип занятости',
                schedule: 'График работы',
                salary: 'Зарплата',
                categoryId: 'Категория',
                isActive: 'Активна',
                sortOrder: 'Порядок сортировки',
                createdAt: 'Создана',
                updatedAt: 'Обновлена',
            },
            employment: {
                FULL_TIME: 'Полная занятость',
                PART_TIME: 'Частичная занятость',
            },
        },
        'contact-groups': {
            name: 'Группа контактов |||| Группы контактов',
            fields: {
                id: 'ID',
                name: 'Название',
                isActive: 'Активна',
                sortOrder: 'Порядок сортировки',
                createdAt: 'Дата создания',
                updatedAt: 'Дата обновления',
            },
        },
        contacts: {
            name: 'Контакт |||| Контакты',
            fields: {
                id: 'ID',
                name: 'Название',
                phone: 'Телефон',
                email: 'Email',
                address: 'Адрес',
                mapLink: 'Ссылка на карту',
                workingHours: 'Часы работы',
                groupId: 'Группа контактов',
                isActive: 'Активен',
                sortOrder: 'Порядок сортировки',
                createdAt: 'Дата создания',
                updatedAt: 'Дата обновления',
            },
        },
        'case-categories': {
            name: 'Категория кейсов |||| Категории кейсов',
            fields: {
                id: 'ID',
                name: 'Название',
                slug: 'Слаг',
                isActive: 'Активна',
                sortOrder: 'Порядок сортировки',
                '_count.cases': 'Количество кейсов',
                createdAt: 'Дата создания',
                updatedAt: 'Дата обновления',
            },
        },
        cases: {
            name: 'Кейс |||| Кейсы',
            fields: {
                id: 'ID',
                title: 'Название',
                slug: 'Слаг',
                mapImage: 'Изображение карты',
                coverImage: 'Обложка',
                from: 'Откуда',
                to: 'Куда',
                machine: 'Техника',
                sliderImages: 'Изображения слайдера',
                time: 'Время доставки (дни)',
                logisticPrice: 'Стоимость логистики',
                exploitationPrice: 'Стоимость эксплуатации',
                bigMapImage: 'Большое изображение карты',
                descriptionTitle: 'Заголовок описания',
                description: 'Описание',
                categoryId: 'Категория',
                isActive: 'Активен',
                sortOrder: 'Порядок сортировки',
                createdAt: 'Дата создания',
                updatedAt: 'Дата обновления',
            },
        },
        'privacy-sections': {
            name: 'Раздел политики |||| Разделы политики',
            fields: {
                id: 'ID',
                subtitle: 'Подзаголовок',
                description: 'Описание',
                items: 'Пункты политики',
                sortOrder: 'Порядок сортировки',
                isActive: 'Активен',
                createdAt: 'Создан',
                updatedAt: 'Обновлен',
            },
        },
        'vacancy-page-data': {
            name: 'Контент страницы |||| Контент страницы',
            fields: {
                id: 'ID',
                email: 'Контактный email',
                images: 'Изображения',
                sliderData: 'Данные слайдера',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
            },
            tabs: {
                contact: 'Контактная информация',
                images: 'Изображения',
                slider: 'Слайдер',
            },
        },
        inquiries: {
            name: 'Заявка |||| Заявки',
            fields: {
                id: 'ID',
                name: 'Имя',
                company: 'Компания',
                phone: 'Телефон',
                email: 'Email',
                comment: 'Комментарий',
                userId: 'Пользователь',
                adminNotes: 'Заметки администратора',
                source: 'Источник',
                ipAddress: 'IP адрес',
                userAgent: 'User Agent',
                createdAt: 'Создана',
                updatedAt: 'Обновлена',
            },
            empty: 'Нет заявок'
        },
    },
    ra: {
        ...russianMessages.ra,
        page: {
            ...russianMessages.ra.page,
            dashboard: 'Панель управления',
        },
    },
    menu: {
        about: 'О нас',
    },
    about: {
        title: 'Управление страницей "О нас"',
        sections: {
            basic: 'Основная информация',
            slider: 'Слайдер',
            list: 'Секция списка',
            info: 'Информационный блок',
            contact: 'Контактная информация',
        },
        tabs: {
            basic: 'Основная информация',
            slider: 'Слайдер',
            advantages: 'Преимущества',
            info: 'Информационный блок',
            contacts: 'Контакты',
        },
        fields: {
            title: 'Заголовок',
            titleDescription: 'Описание заголовка',
            listTitle: 'Заголовок списка',
            listDescription: 'Описание списка',
            listItems: 'Элементы списка',
            infoTitle: 'Заголовок информационного блока',
            infoDescription: 'Описание информационного блока',
            phone: 'Телефон',
            email: 'Email',
            infoImage: 'Изображение',
            sliderText: 'Текст слайда',
            sliderImage: 'Изображение слайда',
            listItemTitle: 'Заголовок элемента',
            listItemText: 'Текст элемента',
        },
        actions: {
            save: 'Сохранить',
            create: 'Создать страницу',
            edit: 'Редактировать',
            addSlide: 'Добавить слайд',
            addListItem: 'Добавить элемент',
            saving: 'Сохранение...',
        },
        messages: {
            notFound: 'Страница О нас не найдена. Создайте новую.',
            created: 'Страница О нас успешно создана',
            updated: 'Страница О нас успешно обновлена',
            loadError: 'Ошибка загрузки данных',
            saveError: 'Ошибка сохранения',
        },
    },
    financing: {
        tabs: {
            basic: 'Основная информация',
            items: 'Элементы финансирования',
        },
        fields: {
            subtitle: 'Подзаголовок',
            description: 'Описание',
            isActive: 'Активно',
            items: 'Элементы финансирования',
            itemTitle: 'Заголовок элемента',
            itemDescription: 'Описание элемента',
        },
        help: {
            itemTitle: 'Название типа финансирования (например, Лизинг)',
            itemDescription: 'Подробное описание условий финансирования',
        },
    },
};

export default customRussianMessages;
